/* eslint-disable complexity */
import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import PostInspectionDiyModal from "../post-inspection-diy-modal";
import { HOLDBACK_DETAILS } from "./constant";
import { Label } from "@cars24/turbo-web/lib/label";
import { NUMBER } from "../../../constants/app-constants";
import { Heading } from "@cars24/turbo-web/lib/heading";
import priceFormatter from "../../../utils/helpers/price-formatter";
import { Badge } from "@cars24/turbo-web/lib/badge";
import { daysUntilRelease } from "../post-inspection-diy-holdbacks-v3/selector";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { BodyText } from "@cars24/turbo-web/lib/body-text";
import { Tags } from "@cars24/turbo-web/lib/tags";

const PostInspectionDiyLoanNocHoldback = ({
    onClose = () => { },
    holds = [],
    type: holdType,
    showBadge = true
}) => {
    const hold = holds.filter(({ label, purpose }) => label === holdType || purpose === holdType);
    const { amount, additionalData, autoReleaseDate, autoForfeitDate } = hold[0] || {};
    const { faqs = [] } = additionalData || {};
    const { title, stepTitle, steps, footer, bottomText } = HOLDBACK_DETAILS[holdType];
    const daysleft = daysUntilRelease(autoReleaseDate || autoForfeitDate);
    const { tokens } = useTokens();

    return (
        <PostInspectionDiyModal
            height="520px"
            isOpen={true}
            width="520px"
            showCloseButton={true}
            onClose={onClose}
        >
            <div>
                <div styleName="styles.holdBackHeaderContainer">
                    <div styleName="styles.holdBackHeading">
                        <Label level={NUMBER.THREE} fontWeight="semibold">{title}</Label>
                        <Heading level={NUMBER.FOUR} color={tokens.text_state_text_error} isBold>₹{priceFormatter(amount)}</Heading>
                    </div>
                    {faqs && !!faqs.length && faqs.map(({ question, answer }) => (<>
                        <Label level={NUMBER.FOUR} fontWeight="semibold">{question}</Label>
                        <BodyText level={NUMBER.TWO} color={tokens.text_default_text_secondary}>{answer.text}</BodyText>
                    </>
                    ))}
                </div>
                <div styleName="styles.stepDetailContainer">
                    <div styleName="styles.badgeHeader">
                        <Label level={NUMBER.THREE} fontWeight="semibold">{stepTitle}</Label>
                        {showBadge && !!daysleft && daysleft > NUMBER.ZERO &&
                            <Badge
                                label={`${daysleft} DAYS LEFT`}
                                type="dark"
                                variant="warning"
                            />
                        }
                    </div>
                    {
                        steps && !!steps.length && steps.map(({ heading, desc, img }, index) =>
                            (<div styleName="styles.stepsTile" key={`steps-details-${index}`}>
                                <div styleName="styles.imageContainer">
                                    <img src={img} alt={`step-${index}`} />
                                    <div styleName="styles.tag">
                                        <Tags
                                            label={index + NUMBER.ONE}
                                            size="small"
                                            variant="primary"
                                        />
                                    </div>
                                </div>
                                <div styleName="styles.contentContainer">
                                    <Label level={NUMBER.FOUR} fontWeight="medium">{heading} </Label>
                                    <BodyText level={NUMBER.THREE} color={tokens.text_default_text_secondary}>{desc}</BodyText>
                                </div>
                            </div>)
                        )}
                    {!!footer &&
                        <div styleName="styles.footerLabel">
                            <Label level={NUMBER.FOUR} fontWeight="regular" color={tokens.text_default_text_secondary} >
                                {footer}</Label>
                        </div>
                    }
                </div>
                {showBadge &&
                    <div styleName="styles.message">
                        <BodyText level={NUMBER.TWO}>
                            Make sure to {bottomText} to receive
                            ₹{priceFormatter(amount)}, or this amount will be cancelled.</BodyText>
                    </div>
                }
            </div>
        </PostInspectionDiyModal>
    );
};

PostInspectionDiyLoanNocHoldback.propTypes = {
    onClose: PropTypes.func,
    holds: PropTypes.array,
    type: PropTypes.string,
    showBadge: PropTypes.bool
};
export default PostInspectionDiyLoanNocHoldback;
